


































import { AcoFormData, FullNormalFormData, PrecheckResult } from '@tt4b/ttam-enums';
import { defineComponent, computed, PropType, toRefs } from '@vue/composition-api';
import { useLanguageMisMatch } from '../hooks';

const name = 'ttam-ad-text-check';
export default defineComponent({
  name,
  props: {
    // 点击提交后，则禁用alert
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    suggestionList: {
      type: Array,
      default: () => [],
    },
    precheckResult: {
      type: Object as PropType<PrecheckResult>,
      default: () => ({
        materialResults: [],
        summaryResults: [],
      }),
    },
    activeCreativeIndex: {
      type: Number,
      default: 0,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { precheckResult, creativeData, activeCreativeIndex } = toRefs(props);
    const { getSuggestion, isShowSuggestionLink } = useLanguageMisMatch({
      precheckResult,
      creativeData,
      activeCreativeIndex,
    });
    const isShowAlert = computed(() => !props.loading && props.suggestionList?.length > 0 && !props.disabled);

    return {
      name,
      isShowAlert,
      getSuggestion,
      isShowSuggestionLink,
    };
  },
});
